import React from 'react';
import PropTypes from 'prop-types';
import Styled from 'styled-components';
import {getDimensions, SIZE} from '../../utils/IntegrationIconSizer';

export const ResetIcon = ({size, onClick}) => {
	const dimensions = getDimensions(size);

	const handleClick = e => {
		/*
			We only want to stop propagation if onClick is set i props
			otherwise we want the click to propagate up
		*/
		if (onClick) {
			e.stopPropagation();
			onClick(e);
		}
	};

	return (
		<StyledSpan onClick={handleClick} width={dimensions} height={dimensions}>
			<svg width={dimensions} height={dimensions} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
				<path
					d="M9.37543 5.94429C10.4858 5.46306 11.7071 5.29637 12.9058 5.46245C14.1045 5.62854 15.2345 6.12099 16.1721 6.88599C16.6731 7.29464 17.2563 7.82157 17.7199 8.25206C17.7373 8.26819 17.7545 8.28417 17.7715 8.29999H15C14.6134 8.29999 14.3 8.61339 14.3 8.99999C14.3 9.38659 14.6134 9.69999 15 9.69999H19.3C19.6866 9.69999 20 9.38659 20 8.99999V4.7C20 4.3134 19.6866 4 19.3 4C18.9134 4 18.6 4.3134 18.6 4.7V7.15892C18.1412 6.73433 17.5662 6.21649 17.0572 5.80119C15.9206 4.87393 14.5509 4.27701 13.0979 4.0757C11.6449 3.87439 10.1646 4.07644 8.8187 4.65975C7.47282 5.24306 6.31321 6.18519 5.46667 7.38312C4.62014 8.58105 4.11925 9.98867 4.01879 11.4521C3.91832 12.9155 4.22214 14.3784 4.89703 15.6807C5.57192 16.9831 6.59189 18.0749 7.84544 18.8366C9.09898 19.5984 10.5378 20.0009 12.0047 20C12.3913 19.9998 12.7045 19.6862 12.7043 19.2996C12.7041 18.913 12.3905 18.5998 12.0039 18.6C10.7937 18.6007 9.60666 18.2687 8.57249 17.6402C7.53831 17.0118 6.69683 16.1111 6.14005 15.0366C5.58327 13.9621 5.33262 12.7553 5.4155 11.548C5.49838 10.3407 5.91161 9.17937 6.61001 8.19107C7.3084 7.20278 8.26507 6.42553 9.37543 5.94429Z"
					fill="#393946"
				/>
			</svg>
		</StyledSpan>
	);
};

ResetIcon.SIZE = SIZE;
ResetIcon.propTypes = {
	onClick: PropTypes.func,
	size: PropTypes.oneOf(Object.values(SIZE)),
};

const StyledSpan = Styled.div`
	display: inline;
	cursor: ${props => (props.onClick ? 'pointer' : 'default')};
	height: ${props => props.height + 'px'};
	width: ${props => props.width + 'px'};
`;
